import api from "@/lib/api";

/**
 * Lightweight fire-and-forget analytics event helper.
 * Backend only accepts authenticated users and a whitelisted set of events.
 * Failures are swallowed so analytics can never break the UX.
 */
export function trackEvent(event, meta = {}) {
  try {
    // Don't block anything on this — no await, no toast on failure
    api.post("/analytics/event", { event, meta }).catch(() => {});
  } catch {
    /* ignore */
  }
}
